import { BaseModel } from '../../_base/crud';
import { Address } from './address.model';
import { SocialNetworks } from './social-networks.model';

export class User extends BaseModel {
  id: number;
  password: string;
  token :string;
  username?: string;
  userName: string;
  firstName?: string;
  lastName?: string;
  email?: string;
  accessToken?: string;
  refreshToken?: string;
  roles?: number[];
  pic?: string;
  fullname?: string;
  occupation?: string;
  companyName?: string;
  phone?: string;
  address?: Address;
  socialNetworks?: SocialNetworks;
  userProject?:[];
  defaultProjectId?: number | string;
  selectedProjectId?: number | string;
  userId?: number | string;
  region?: string;
  appServerUrl?:string;
  projectType?: string;

  clear(): void {
    this.id = undefined;
    this.username = '';
    this.userName = '';
    this.firstName = '';
    this.lastName = '';
    this.password = '';
    this.email = '';
    this.roles = [];
    this.fullname = '';
    this.accessToken = 'access-token-' + Math.random();
    this.refreshToken = 'access-token-' + Math.random();
    this.pic = './assets/media/users/default.jpg';
    this.occupation = '';
    this.companyName = '';
    this.phone = '';
    this.address = new Address();
    this.address.clear();
    this.socialNetworks = new SocialNetworks();
    this.socialNetworks.clear();
    this.userProject = [];
    this.userId = '';
    this.region = '';
    this.projectType = '';
  }
}